import React, { useEffect, useState } from "react";
import Layout from "../layoutComponent/Layout";
import toast from "react-hot-toast";
import axios from "axios";
import { liveUrl } from "../../utils/Constant";
import Pagination from "../Modals/Pagination";

const SupportForm = () => {
    const [formData, setFormData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 5;

    const fetchSupportForm = async () => {
        try {
            const res = await axios.get(`${liveUrl}/support/all?page=${page}&limit=${limit}`, {

            });
            // console.log(res)
            if (Array.isArray(res.data.data)) {
                setFormData(res.data.data);
                setTotalPages(res.data.pagination.totalPages);
            } else {
                setFormData([]);
            }
        } catch (error) {
            toast.error("Failed to load data");
            setFormData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSupportForm();
    }, [page]);

    const handleDelete = async (id) => {
        const confirmDelete = await new Promise((resolve) => {
            const toastId = toast(
                (t) => (
                    <div>
                        <p>Are you sure you want to delete this entry?</p>
                        <div style={{ marginTop: "8px", display: "flex", gap: "8px", justifyContent: 'center', alignItems: 'center' }}>
                            <button
                                onClick={() => {
                                    toast.dismiss(t.id);
                                    resolve(true);
                                }}
                                style={{
                                    background: "red",
                                    color: "white",
                                    borderRadius: "4px",
                                    border: 'none',
                                    padding: "4px 8px",
                                    cursor: "pointer",
                                }}
                            >
                                Yes
                            </button>
                            <button
                                onClick={() => {
                                    toast.dismiss(t.id);
                                    resolve(false);
                                }}
                                style={{
                                    background: "gray",
                                    color: "white",
                                    borderRadius: "4px",
                                    border: 'none',
                                    padding: "4px 8px",
                                    cursor: "pointer",
                                }}
                            >
                                No
                            </button>
                        </div>
                    </div>
                ),
                { duration: Infinity }
            );
        });

        if (!confirmDelete) return;

        try {
            await axios.delete(`${liveUrl}/support/${id}`, {

            });

            setFormData((prev) => prev.filter((item) => item._id !== id));
            toast.success("Deleted successfully");
        } catch (error) {
            toast.error("Failed to delete");
        }
    };

    return (
        <Layout>
            <div className="banner-container">
                <div className="banner-header">
                    <h2>Support Form Data</h2>
                </div>

                {loading ? (
                    <p style={{ textAlign: "center" }}>Loading...</p>
                ) : (
                    <div className="table-wrapper">
                        <table className="banner-table">
                            <thead>
                                <tr>
                                    <th>S.NO</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Message</th>
                                    <th>Insurance</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {formData.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center" }}>
                                            No data found
                                        </td>
                                    </tr>
                                ) : (
                                    formData.map((item, index) => (
                                        <tr key={item._id}>
                                            <td>{(page - 1) * limit + index + 1}</td>
                                            <td>{item.name}</td>
                                            <td>{item.phoneNumber}</td>
                                            <td>{item.message}</td>
                                            <td>{item.insurance}</td>
                                            <td>
                                                <button
                                                    className="delete-btn"
                                                    onClick={() => handleDelete(item._id)}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={(newPage) => setPage(newPage)}
            />
        </Layout>
    );
};

export default SupportForm;
